"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roleList = exports.removeRole = exports.insertRoleMenu = exports.getRoleMenuTreeListForRole = exports.getRoleMenuByRoleId = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取角色列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var roleList = exports.roleList = function roleList(data) {
  return _api.default.request({
    url: '/role/roleList',
    method: 'post',
    data: data
  });
};

/**
 * 获取角色树关系
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var getRoleMenuTreeListForRole = exports.getRoleMenuTreeListForRole = function getRoleMenuTreeListForRole(data) {
  return _api.default.request({
    url: '/roleMenu/getRoleMenuTreeListForRole',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};

/**
 * 获取角色绑定的所有菜单
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var getRoleMenuByRoleId = exports.getRoleMenuByRoleId = function getRoleMenuByRoleId(data) {
  return _api.default.request({
    url: '/roleMenu/getRoleMenuByRoleId',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};

/**
 * 插入或者角色以及权限
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var insertRoleMenu = exports.insertRoleMenu = function insertRoleMenu(data) {
  return _api.default.request({
    url: '/roleMenu/insertRoleMenu',
    method: 'post',
    data: data
  });
};
/**
 * 移除角色
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var removeRole = exports.removeRole = function removeRole(data) {
  return _api.default.request({
    url: '/role/removeRole',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};